import { PropsWithChildren } from 'react';

import { StyledPropertyColumn } from './styles';

const PropertyColumn = ({ children }: PropsWithChildren) => (
  <StyledPropertyColumn>{children}</StyledPropertyColumn>
);

export default PropertyColumn;
